import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0C0E]">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#D4AF37]/30 border-t-[#D4AF37]" />
    </div>
  );
}

export function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/portal" replace />;
  if (role === "retailer") {
    if (user.role === "admin") return children;
    if (user.role !== "retailer") return <Navigate to="/" replace />;
    if (user.status !== "approved") return <Navigate to="/portal/pending" replace />;
  }
  return children;
}
